export const dialogSx = {
  '& h2': {
    p: '24px 64px',
  },
  '& .MuiDialogActions-root': {
    p: '8px 64px 16px',
  },
  '& .MuiDialogContent-root': {
    p: '16px 64px',
  },
};
